<div class="modal-header" appCustomAutofocus>
    <h3 class="modal-title">Add Attachments</h3>
</div>
<div class="modal-body">
    <div class="col-md-12" *ngIf="alert != null">
        <div class="alert" [ngClass]="{'alert-success' : alert.type == 'success', 'alert-default' : alert.type == 'default', 'alert-danger': alert.type == 'danger' }" role="alert">
            {{alert.msg}}
            <button type="button" class="close" (click)="closeAlert()">
                <i class="modus-icons">close</i>
            </button>
        </div>
    </div>
    <label><strong>Attachments&nbsp; </strong></label>
    <div *ngFor="let file of savedFiles" style="margin-bottom: 15px;">
        <a href="/Employee/GetFileAttachmentData?fileAttachmentID={{file.FileAttachmentID}}"> {{file.AttachmentFileName}}</a>
        <button class="btn btn-danger btn-icon-only ml-1 mr-3 float-right" (click)="deleteSavedAttachment(file)" *ngIf="!status">
            <i class="modus-icons">close</i>
        </button>
    </div>
    <label *ngIf="newFiles.length > 0"><strong>pending save</strong></label>
    <br *ngIf="newFiles.length > 0" />
    <div *ngFor="let file of newFiles" style="margin-top: 20px">
        {{file.Filename}}
        <button class="btn btn-danger btn-icon-only ml-1 mr-3" (click)="deleteUnsavedAttachment(file)" *ngIf="file.File != null && file.Progress == null && !status">
            <i class="modus-icons">close</i>
        </button>
        <div style="padding-left:15px;margin-top:5px;">
            <div class="progress" style="width:250px;" *ngIf="file.Progress > 0">
                <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': file.Progress + '%' }">{{file.Progress}}%</div>
            </div>
        </div>
    </div>
    <br/>
    <div id="fileDrop"
         *ngIf="!status"
         style="cursor:pointer;"
         ngfDrop
         multiple="1"
         selectable="1"
         [(validDrag)]="validComboDrag"
         [(files)]="formData.fileDrop"
         [fileDropDisabled]="!allowMultipleAttachments && mobileMode && newFiles.length > 0"
         accept=".pdf,.jpg,.jpeg,.gif,.tif,.tiff,.png,.bmp,.doc,.docx,.xls,.xlsx,.ppt,.pps,.pptx,.ppsx,.sldx"
         [(dragFiles)]="dragFiles"
         class="drop-box"
         [class.invalid-drag]="validComboDrag===false"
         [class.valid-drag]="validComboDrag"
         (filesChange)="upload()" [ngfFixOrientation]="false">
        Drop a file or Click to upload
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary"
            (click)="saveClicked()"
            *ngIf="!status"
            [disabled]="newFiles.length < 1 || formData.disableButton">
        Save
    </button>
    <button type="button" class="btn btn-outline-dark" (click)="closeClicked()">Close</button>
</div>